import styled from 'styled-components'

import { breakpoint, space } from 'app/theme/tokens'

export const CalculatorLink = styled.a`
  display: inline-block;
  margin-bottom: ${space.md};
  font-size: 14px;
  color: inherit;
  text-decoration: underline;
`

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  /* Mobile: stack program cards vertically — they're each ~280px wide on
     desktop so trying to fit 3 side by side on a 375px screen forces a
     horizontal scroll inside an already-scrolling page. */
  ${breakpoint.down('tablet')} {
    flex-direction: column;
    gap: ${space.md};
  }
`
